import {CareerEnum, LevelEnum} from '@/types/nftAttribute'

export type careerDataType = Record<
  CareerEnum,
  {
    name: string
    img: Record<LevelEnum, string>
    desc: string
    link?: string
    ability: string
  }
>

export const CAREER_DATA: careerDataType = {
  [CareerEnum.HardwareDruid]: {
    name: 'Hardware Druid',
    desc: 'Outstanding Hardware Druids will customize their own robots to match their characteristics.',
    img: {
      [LevelEnum.Legendary]:
        '/static/images/mintPage/icon/icons/career/Legendary/HardwareDruid.png',
      [LevelEnum.Magic]:
        '/static/images/mintPage/icon/icons/career/Magic/HardwareDruid.png',
      [LevelEnum.Common]:
        '/static/images/mintPage/icon/icons/career/PrimeEdition/HardwareDruid.png',
    },
    link: 'https://phala-nft-app.netlify.app/',
    ability: 'Intelligence advantage.',
  },
  [CareerEnum.RoboWarrior]: {
    name: 'Robo Warrior',
    desc: "Mechanical strength determines Warrior's fighting ability no matter which species they are.",
    img: {
      [LevelEnum.Legendary]:
        '/static/images/mintPage/icon/icons/career/Legendary/RoboWarrior.png',
      [LevelEnum.Magic]:
        '/static/images/mintPage/icon/icons/career/Magic/RoboWarrior.png',
      [LevelEnum.Common]:
        '/static/images/mintPage/icon/icons/career/PrimeEdition/RoboWarrior.png',
    },
    link: 'https://phala-nft-app.netlify.app/',
    ability: 'Strength advantage.',
  },
  [CareerEnum.TradeNegotiator]: {
    name: 'Trade Negotiator',
    desc: 'Trade Negotiator are a relatively common group, but they play the most important role in trade and are the core of the circulation of wealth, goods and money. ',
    img: {
      [LevelEnum.Legendary]:
        '/static/images/mintPage/icon/icons/career/Legendary/TradeNegotiator.png',
      [LevelEnum.Magic]:
        '/static/images/mintPage/icon/icons/career/Magic/TradeNegotiator.png',
      [LevelEnum.Common]:
        '/static/images/mintPage/icon/icons/career/PrimeEdition/TradeNegotiator.png',
    },
    link: 'https://phala-nft-app.netlify.app/',
    ability: 'Dexterity advantage.',
  },
  [CareerEnum.HackerWizard]: {
    name: 'Hacker Wizard',
    desc: 'Fascinated by the power of controlling the elements, some engineers began to call themselves "Hacker Wizard", which can change the world in your eyes.',
    img: {
      [LevelEnum.Legendary]:
        '/static/images/mintPage/icon/icons/career/Legendary/HackerWizard.png',
      [LevelEnum.Magic]:
        '/static/images/mintPage/icon/icons/career/Magic/HackerWizard.png',
      [LevelEnum.Common]:
        '/static/images/mintPage/icon/icons/career/PrimeEdition/HackerWizard.png',
    },
    link: 'https://phala-nft-app.netlify.app/',
    ability: 'Intelligence advantage.',
  },
  [CareerEnum.Web3Monk]: {
    name: 'Web 3.0 Monk',
    desc: "Monk's understanding of Web3 and the graphene algorithm is far superior to ordinary people.",
    img: {
      [LevelEnum.Legendary]:
        '/static/images/mintPage/icon/icons/career/Legendary/Web3.0Monk.png',
      [LevelEnum.Magic]:
        '/static/images/mintPage/icon/icons/career/Magic/Web3.0Monk.png',
      [LevelEnum.Common]:
        '/static/images/mintPage/icon/icons/career/PrimeEdition/Web3.0Monk.png',
    },
    link: 'https://phala-nft-app.netlify.app/',
    ability: 'Willpower advantage.',
  },
}

export const CAREER_ICON_IMG_MAP = {
  [LevelEnum.Legendary]: {
    [CareerEnum.HardwareDruid]:
      '/static/images/mintPage/icon/career-icons/Legendary/HardwareDruid.png',
    [CareerEnum.HackerWizard]:
      '/static/images/mintPage/icon/career-icons/Legendary/HackerWizard.png',
    [CareerEnum.RoboWarrior]:
      '/static/images/mintPage/icon/career-icons/Legendary/RoboWarrior.png',
    [CareerEnum.TradeNegotiator]:
      '/static/images/mintPage/icon/career-icons/Legendary/TradeNegotiator.png',
    [CareerEnum.Web3Monk]:
      '/static/images/mintPage/icon/career-icons/Legendary/Web3.0Monk.png',
  },
  [LevelEnum.Magic]: {
    [CareerEnum.HardwareDruid]:
      '/static/images/mintPage/icon/career-icons/Magic/HardwareDruid.png',
    [CareerEnum.HackerWizard]:
      '/static/images/mintPage/icon/career-icons/Magic/HackerWizard.png',
    [CareerEnum.RoboWarrior]:
      '/static/images/mintPage/icon/career-icons/Magic/RoboWarrior.png',
    [CareerEnum.TradeNegotiator]:
      '/static/images/mintPage/icon/career-icons/Magic/TradeNegotiator.png',
    [CareerEnum.Web3Monk]:
      '/static/images/mintPage/icon/career-icons/Magic/Web3.0Monk.png',
  },
  [LevelEnum.Common]: {
    [CareerEnum.HardwareDruid]:
      '/static/images/mintPage/icon/career-icons/PrimeEdition/HardwareDruid.png',
    [CareerEnum.HackerWizard]:
      '/static/images/mintPage/icon/career-icons/PrimeEdition/HackerWizard.png',
    [CareerEnum.RoboWarrior]:
      '/static/images/mintPage/icon/career-icons/PrimeEdition/RoboWarrior.png',
    [CareerEnum.TradeNegotiator]:
      '/static/images/mintPage/icon/career-icons/PrimeEdition/TradeNegotiator.png',
    [CareerEnum.Web3Monk]:
      '/static/images/mintPage/icon/career-icons/PrimeEdition/Web3.0Monk.png',
  },
}
